module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('address-blank-form', _vm._b({
    attrs: {
      "submit-label": "Сохранить",
      "form-type": "edit",
      "errors": _vm.errors
    },
    on: {
      "submit": _vm.processAddressForm
    }
  }, 'address-blank-form', _vm.$attrs, false))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f0fa896","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/address/AddressEditForm.vue
// module id = 616
// module chunks = 0